import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const AbsoluteLine = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="8.69"
      y1="15.49"
      x2="8.69"
      y2="8.57"
      fill="none"
      stroke="#ee312e"
      strokeDasharray="0 0 1.37 1.37"
      strokeMiterlimit={10}
    />
    <line
      x1="9.19"
      y1="15.49"
      x2="16.76"
      y2="15.49"
      fill="none"
      stroke="#ee312e"
      strokeDasharray="0 0 1.37 1.37"
      strokeMiterlimit={10}
    />
    <line
      x1="20.8"
      y1="4.06"
      x2="3.2"
      y2="20.28"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.77px"
    />
    <circle cx="8.69" cy="15.49" r="2.08" fill="#fff" />
    <path d="m8.69,4.55l1.09-2.67h.76l-1.51,3.34v1.98h-.67v-1.98l-1.51-3.34h.76l1.09,2.67Z" fill="#fdfefe" />
    <path
      d="m18.58,14.87l1-2.04h.79l-1.38,2.64,1.41,2.68h-.79l-1.02-2.08-1.03,2.08h-.79l1.42-2.68-1.39-2.64h.78l1.01,2.04Z"
      fill="#fdfefe"
    />
    <polygon points="22.59 2.46 21.98 4.43 21.37 6.39 19.97 4.88 18.58 3.36 20.59 2.91 22.59 2.46" fill="#ee312e" />
    <polygon points="5.44 20.96 3.43 21.4 1.42 21.83 2.05 19.87 2.67 17.92 4.06 19.44 5.44 20.96" fill="#ee312e" />
  </svg>,
  'Absolute Line',
);

export const ExactLine = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    style={{ strokeLinecap: 'round', strokeMiterlimit: 10 }}
  >
    <g transform="matrix(4.166667,0,0,4.506576,45.958333,-4.078913)">
      <path d="M0.97,2.07L0.97,21.93" fill="none" stroke="rgb(253,254,254)" strokeWidth="1.76px" />
    </g>
    <g transform="matrix(4.166667,0,0,3.346,-45.708333,13.214277)">
      <path d="M22.97,2.07L22.97,21.93" fill="none" stroke="rgb(238,49,46)" strokeWidth="2.02px" />
    </g>
    <g transform="matrix(4.166667,0,0,4.166667,-51.752324,3.366275)">
      <path d="M20.34,12L18.56,13.03L16.77,14.06L16.77,9.94L18.56,10.97L20.34,12Z" fill="rgb(238,49,46)" />
    </g>
    <g transform="matrix(-4.166667,0,0,4.166667,151.752324,3.366275)">
      <path d="M20.34,12L18.56,13.03L16.77,14.06L16.77,9.94L18.56,10.97L20.34,12Z" fill="rgb(238,49,46)" />
    </g>
    <g transform="matrix(4.166667,0,0,4.166667,33,-29.550391)">
      <circle cx="4.08" cy="19.92" r="2.08" fill="white" />
    </g>
  </svg>,
  'Exact Line',
);

export const ParallelLine = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="22.97"
      y1="2.07"
      x2="22.97"
      y2="21.93"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.83px"
    />
    <line
      x1=".97"
      y1="2.07"
      x2=".97"
      y2="21.93"
      fill="#f8f7f7"
      stroke="#fdfefe"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.83px"
    />
    <g>
      <line x1="3.68" y1="12" x2="4.36" y2="12" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
      <line
        x1="5.74"
        y1="12"
        x2="16.09"
        y2="12"
        fill="none"
        stroke="#ee312e"
        strokeDasharray="0 0 1.38 1.38"
        strokeMiterlimit="10"
      />
      <line x1="16.78" y1="12" x2="17.46" y2="12" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
    </g>
    <polygon points="20.34 12 18.56 13.03 16.77 14.06 16.77 12 16.77 9.94 18.56 10.97 20.34 12" fill="#ee312e" />
  </svg>,
  'Parallel Line',
);

export const PerpendicularLine = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="12"
      y1="2.07"
      x2="12"
      y2="21.93"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="2px"
    />
    <polyline points="12.98 9.62 18.04 9.62 18.04 15" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
    <line
      x1="1.63"
      y1="16"
      x2="22.37"
      y2="16"
      fill="#fff"
      stroke="#fff"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="2px"
    />
  </svg>,
  'Perpendicular Line',
);

export const PointSlopeLine = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="22.74"
      y1="1.17"
      x2="1.23"
      y2="22.78"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="2px"
    />
    <path d="m13.35,11.15s4.7,3.2,1.97,8.77" fill="none" stroke="#ee312e" strokeMiterlimit={10} strokeWidth=".7px" />
    <line
      x1="4.08"
      y1="19.92"
      x2="22.37"
      y2="19.92"
      fill="none"
      stroke="#ee312e"
      strokeMiterlimit={10}
      strokeWidth=".7px"
    />
    <circle cx="4.08" cy="19.92" r="2.08" fill="#fff" />
  </svg>,
  'Point-Slope Line',
);

export const PointToPointLine = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="21.81"
      y1="2.21"
      x2="2.21"
      y2="21.83"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="2px"
    />
    <circle cx="2.21" cy="21.83" r="2.08" fill="#fff" />
    <circle cx="21.56" cy="2.46" r="2.08" fill="#fff" />
  </svg>,
  'Point-To-Point Line',
);

export const DivisionLine = createSvgIcon(
  <svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <line
      x1="22.98"
      y1="2.24"
      x2="22.98"
      y2="22.1"
      fill="#f8f7f7"
      stroke="#fdfefe"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.83px"
    />
    <line
      x1="12.98"
      y1="2.24"
      x2="12.98"
      y2="22.1"
      fill="#ee312e"
      stroke="#ee312e"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.83px"
    />
    <line
      x1=".98"
      y1="2.24"
      x2=".98"
      y2="22.1"
      fill="#f8f7f7"
      stroke="#fdfefe"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth="1.83px"
    />
    <g>
      <line x1="1.93" y1="12.17" x2="2.62" y2="12.17" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
      <line
        x1="4"
        y1="12.17"
        x2="11.61"
        y2="12.17"
        fill="none"
        stroke="#ee312e"
        strokeDasharray="0 0 1.38 1.38"
        strokeMiterlimit={10}
      />
      <line x1="12.3" y1="12.17" x2="12.98" y2="12.17" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
    </g>
    <g>
      <line x1="12.98" y1="12.17" x2="13.67" y2="12.17" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
      <line
        x1="15.2"
        y1="12.17"
        x2="20.57"
        y2="12.17"
        fill="none"
        stroke="#ee312e"
        strokeDasharray="0 0 1.54 1.54"
        strokeMiterlimit={10}
      />
      <line x1="21.34" y1="12.17" x2="22.03" y2="12.17" fill="none" stroke="#ee312e" strokeMiterlimit={10} />
    </g>
  </svg>,
  'Division Line',
);
